import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {SpellCheckerService} from 'ngx-spellchecker';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class SpellingService {
  private dictionaryURL = '/assets/misc/normalized_en-US.dic';
  private currentDictionary: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(private spellCheckerService: SpellCheckerService,
              private httpClient: HttpClient) {
    this.httpClient.get(this.dictionaryURL, {responseType: 'text'}).subscribe(res => {
      const dictionary = this.spellCheckerService.getDictionary(res);
      dictionary.addRegex(/APU/g);
      dictionary.addRegex(/B-777/g);
      dictionary.addRegex(/B-767/g);
      dictionary.addRegex(/B-757/g);
      dictionary.addRegex(/-/g);
      dictionary.addRegex(/.*\/*./g);
      dictionary.addRegex(/No./g);
      dictionary.addRegex(/[0-9]/g);
      dictionary.addRegex(/FADEC/g);

      this.currentDictionary.next(dictionary);
    });
  }

  checkSpelling(text: string): Observable<boolean> {
    return this.currentDictionary.pipe(
      map(dictionary => {
        const splitText = text.split(' ');
        const results = splitText.map(t => dictionary.spellCheck(t));

        return !results.includes(false);
      })
    );
  }

  getSuggestions(text: string): Observable<Array<{ word: string; misspelled?: boolean; suggestions?: string[] }>> {
    return this.currentDictionary.pipe(
      map(dictionary => {
        const splitText = text.split(' ');
        return splitText.map(t => {
          const result: { word: string; misspelled?: boolean; suggestions?: string[] } = {word: t};

          Object.assign(result, dictionary.checkAndSuggest(t));

          return result;
        }).filter(r => r.misspelled === true);
      })
    );
  }
}
